import { ExModule } from "vuex";
import { State, Actions, Getters, Mutations } from "./types";
import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

const state: State = {
  nextPlanId: 3,
  currentPlan: undefined,
  competitorEmbeddeds: [],
  competitorErrors: [],
  studentEmbeddeds: [],
  studentErrors: [],
  isUpdateUniversity: false,
  studentJobHuntingTrendCollection: undefined
};

const plansModule: ExModule<State, Actions, Getters, Mutations> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default plansModule;
